// The server world remains a 2D plane. Height is presentation only.
export const WORLD_SCALE = 0.01;
export const radians = (degrees: number): number => degrees * Math.PI / 180;
export const normalizeAngle = (angle: number): number => ((angle % 360) + 360) % 360;

export function forward(angle: number): { x: number; y: number } {
	return { x: Math.sin(radians(angle)), y: -Math.cos(radians(angle)) };
}

export function movementAngle(yaw: number, ahead: number, right: number): number | null {
	if (!ahead && !right) return null;
	return normalizeAngle(yaw + Math.atan2(right, ahead) * 180 / Math.PI);
}

export function worldCenter(x: number, y: number, width: number, depth = width): { x: number; z: number } {
	return { x: (x + width / 2) * WORLD_SCALE, z: (y + depth / 2) * WORLD_SCALE };
}

export function aimPoint(x: number, y: number, angle: number, distance = 600): { x: number; y: number } {
	const direction = forward(angle);
	return { x: x + direction.x * distance, y: y + direction.y * distance };
}
